import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing.km2};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: ${theme.border.radius.medium};

    :hover {
      cursor: pointer;
      background-color: ${theme.color.background.neutral.weak};
    }
  `}
`;

export const NameWrapper = styled.span`
  text-transform: capitalize;

  fuel-typography {
    white-space: nowrap;

    p {
      overflow: hidden;
      text-overflow: ellipsis;
      }
    }

    fuel-typography, fuel-typography > p {
      display: inline-grid;
      max-width: 100%;
      width: 100%;
    }
  }
`;

export const TagWrapper = styled.span`
  margin-left: ${({ theme }) => theme.spacing.km1};
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const DividerWrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing.km2};
  `}
`;
